<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      *这个页面只有特定用户才能看到
    </div>
    <div class="md-layout-item md-size-100">
      <md-button class= " md-info" @click="exportApi">
        发送请求
      </md-button>
      <md-button class= " md-info" @click="trdApi">
        发送第三方请求
      </md-button>
      <md-button class= " md-info" @click="clearLeft">
        清除左侧数据
      </md-button>
    </div>
    <div class="md-layout-item md-size-50">
      <md-card>
        <md-card-content>
          <div class="md-layout card-form">
            <div class="md-layout md-layout-item md-size-100 no-margin-layout-item">
              <md-field>
                <label>URL</label>
                <md-input v-model="url"/>
              </md-field>
            </div>
            <div class="md-layout md-layout-item md-size-100 no-margin-layout-item">
              <md-field>
                <label>发送数据</label>
                <md-textarea class="big-textarea" v-model="sendData"/>
              </md-field>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
    <div class="md-layout-item md-size-50">
      <md-card>
        <!-- 正常回调 -->
        <md-card-content v-if="!errorMsg">
          <div class="md-layout card-form" >
            <div class="md-layout md-layout-item md-size-100 no-margin-layout-item">
              <md-field :class="{'md-error': resultData.code !== 200}">
                <label>Code</label>
                <md-input v-model="resultData.code"/>
              </md-field>
            </div>
            <div v-if="!isNaN(resultData.count)" class="md-layout md-layout-item md-size-100 no-margin-layout-item">
              <md-field >
                <label>Code</label>
                <md-input v-model="resultData.count"/>
              </md-field>
            </div>
            <div class="md-layout md-layout-item md-size-100 no-margin-layout-item">
              <md-field>
                <label>回调数据</label>
                <md-textarea class="big-textarea" v-model="resultData.data"/>
              </md-field>
            </div>
          </div>
        </md-card-content>
        <!-- 错误时候的回调 -->
        <md-card-content v-else>
          <div class="md-layout card-form" >
            <div class="md-layout md-layout-item md-size-100 no-margin-layout-item">
              <md-field class="md-error">
                <label>报错信息</label>
                <md-input v-model="errorMsg"/>
              </md-field>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
export default {
  components: {

  },
  data() {
    return {
      url:"",
      sendData:"",
      resultData:{},
      errorMsg: "",
    };
  },
  beforeCreate(){
    if(this.UserInfo.user_id !== "wuadmin" && this.UserInfo.user_name !== "wuadmin"){
      this.$router.push("/")
    }
  },
  mounted : function() {

  },
  watch: {

  },
  computed: {

  },
  methods: {
    trdApi(){
      let sendData = {}
      try {
        sendData = eval(`(${this.sendData})`)
      } catch  {
        sendData = {};
      }
        
      let atherAxios = axios.create({
          headers:{
              Authorization:"Bearer "+ localStorage.acc_token,
          },
      })
      return atherAxios.post(this.url, sendData)
          .then(resp => { // 正常请求回调
              console.log(`${this.url} POST 参数: `, sendData, `回调: `, resp.data)
              this.errorMsg = "";
              this.resultData = {
                data: sendData,
              }
              return resp.data
          })
          .catch(err => { // => 401 
              console.log(`${this.url} POST 参数: `, sendData)
              console.error(`${this.url} POST 回调报错: `, err)
          });
    },
    exportApi(){
      let sendData = {}
      try {
        sendData = eval(`(${this.sendData})`)
      } catch  {
        sendData = {};
      }
      window.$postData(this.url, sendData)
        .then(res => {
          this.errorMsg = ""
          this.resultData = {
            ...res,
            data: res.data 
              ? JSON.stringify(res.data).replace(/,"/g, ',\n"').replace(/{"/g, '{\n"').replace(/"}/g, '"\n}').replace(/]}/g, ']\n}')
              : "",
          }
        })
        .catch(err => {
          this.resultData = {};
          this.errorMsg = err.message
        })
    },
    clearLeft(){
      this.url = ""
      this.sendData = "";
    },
  },
}
</script>
<style lang="scss" scoped>
  .big-textarea{
    min-height: 600px !important;
    max-height: unset;
  }
  label{
    width: 100%;
    background: #ffffff;
  }
</style>
